import { Permission } from '@i9portal/shared';
import type { NavSection } from '../../types/ui';

export const NAV_SECTIONS: NavSection[] = [
  {
    title: 'Minhas solicitações',
    items: [
      { to: '/', label: 'Início', requiresEmployee: true, end: true },
      { to: '/horas-extras', label: 'Horas extras', requiresEmployee: true },
      { to: '/reembolsos', label: 'Reembolsos', requiresEmployee: true },
      { to: '/minha-jornada', label: 'Minha jornada', requiresEmployee: true },
    ],
  },
  {
    title: 'RH',
    items: [
      { to: '/rh', label: 'Dashboard', permissions: [Permission.DASHBOARD_READ], end: true },
      {
        to: '/rh/solicitacoes',
        label: 'Solicitações',
        permissions: [Permission.REQUESTS_READ_ALL],
      },
      {
        to: '/rh/funcionarios',
        label: 'Por funcionário',
        permissions: [Permission.DASHBOARD_READ],
      },
      { to: '/rh/pagamentos', label: 'Pagamentos', permissions: [Permission.REQUESTS_READ_ALL] },
    ],
  },
  {
    title: 'Administração',
    items: [
      { to: '/admin/usuarios', label: 'Usuários', permissions: [Permission.USERS_READ] },
      {
        to: '/admin/feriados',
        label: 'Feriados e folgas',
        permissions: [Permission.CATALOG_MANAGE],
      },
      { to: '/admin/cadastros', label: 'Cadastros', permissions: [Permission.CATALOG_MANAGE] },
      {
        to: '/admin/configuracoes',
        label: 'Configurações',
        permissions: [Permission.SETTINGS_MANAGE],
      },
      { to: '/admin/auditoria', label: 'Auditoria', permissions: [Permission.AUDIT_READ] },
      {
        to: '/admin/notificacoes',
        label: 'Envio de notificações',
        permissions: [Permission.NOTIFICATIONS_MANAGE],
      },
    ],
  },
  {
    title: 'Conta',
    items: [
      { to: '/notificacoes', label: 'Notificações' },
      { to: '/perfil', label: 'Meu perfil' },
    ],
  },
];
